import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import {
  LayoutDashboard,
  Building2,
  Users,
  Package,
  Hammer,
  MessageSquare,
  LogOut,
  Home,
  Star,
  FileText,
} from "lucide-react";
import { SITE } from "@/lib/site";

const links = [
  { to: "/admin", icon: LayoutDashboard, label: "Panel", end: true, testId: "side-dashboard" },
  { to: "/admin/yalitim", icon: Building2, label: "Yalıtım / Binalar", testId: "side-buildings" },
  { to: "/admin/referanslar", icon: Star, label: "Referanslar", testId: "side-references" },
  { to: "/admin/icerik", icon: FileText, label: "Sayfa İçerikleri", testId: "side-content" },
  { to: "/admin/personel", icon: Users, label: "Personel", testId: "side-personnel" },
  { to: "/admin/malzeme", icon: Package, label: "Malzeme", testId: "side-materials" },
  { to: "/admin/yapsat", icon: Hammer, label: "Yap-Sat", testId: "side-yapsat" },
  { to: "/admin/mesajlar", icon: MessageSquare, label: "Mesajlar", testId: "side-messages" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };
  return (
    <div className="min-h-screen flex bg-[#0a0a0a] text-white">
      <aside className="w-64 shrink-0 bg-[#121212] border-r border-[#d4af37]/15 flex flex-col">
        <Link to="/admin" data-testid="admin-brand" className="p-5 border-b border-white/5 flex items-center gap-3">
          <img src={SITE.logo} alt="Kardeşler Yapı" className="h-10 w-10 rounded-sm object-cover ring-1 ring-[#d4af37]/40" />
          <div>
            <div className="font-display tracking-tight">KARDEŞLER YAPI</div>
            <div className="font-mono text-[10px] tracking-[0.32em] text-[#d4af37]">A D M I N · C R M</div>
          </div>
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm transition border-l-2 ${
                  isActive
                    ? "bg-[#d4af37]/10 text-[#d4af37] border-[#d4af37]"
                    : "text-white/70 border-transparent hover:text-white hover:bg-white/5"
                }`
              }
            >
              <l.icon className="h-4 w-4" />
              <span>{l.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/5 space-y-1">
          <Link to="/" data-testid="admin-go-site" className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-white hover:bg-white/5 transition">
            <Home className="h-4 w-4" /> Siteyi Görüntüle
          </Link>
          <button onClick={handleLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-white/60 hover:text-[#d4af37] hover:bg-white/5 transition">
            <LogOut className="h-4 w-4" /> Çıkış Yap
          </button>
          <div className="px-3 pt-2 text-[10px] text-white/30 font-mono">
            {user?.username || "Admin"} · ROLE: ADMIN
          </div>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden kc-scroll" data-testid="admin-main">
        <div className="p-6 md:p-10 max-w-[1500px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
